import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./NotificationUIHelpers";

const NotificationUIContext = createContext();

export function useNotificationUIContext() {
  return useContext(NotificationUIContext);
}

export const NotificationUIConsumer = NotificationUIContext.Consumer;

export function NotificationUIProvider({ notificationUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initNotification = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initNotification,
    newNotificationButtonClick: notificationUIEvents.newNotificationButtonClick,
    openEditNotificationPage: notificationUIEvents.openEditNotificationPage,
    openNotificationFilePage: notificationUIEvents.openNotificationFilePage
  };

  return (
    <NotificationUIContext.Provider value={value}>
      {children}
    </NotificationUIContext.Provider>
  );
}
